import { get } from '../utils/api';
import { BASE_URL } from '../utils/consts';

export function getChatToken(params) {
  return get(`${BASE_URL}/chat/access-token`, params);
}
